<div class="template-card" [ngClass]="{'loading': isLoading, 'inactive': inactive}"
  (click)="inactive === false && selectTemplate()" [style.background-image]="'url(' + template.path + ')'">
  <div class="template-info programs-body-1">
    <div *ngIf="!hasFailed && !isLoading" class="programs-h6 text-truncate">{{ template.title }}</div>
    <div *ngIf="!hasFailed && !isLoading" class="template-description">{{ template.description }}</div>
    <div *ngIf="!hasFailed && isLoading" class="template-loader">
      <mat-spinner [diameter]="48"></mat-spinner>
    </div>
    <div *ngIf="hasFailed" class="template-error">
      Error while creating the Experience.<br />Please refresh.
    </div>
  </div>
</div>